// src/components/FormatComptePage.tsx
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Box, Button, TextField, Typography, CircularProgress, Alert,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
  IconButton, Dialog, DialogTitle, DialogContent, DialogActions, FormControlLabel, Checkbox
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import CloseIcon from '@mui/icons-material/Close';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ViewListIcon from '@mui/icons-material/ViewList';
//import { FormatCompte, FormatCompteDto } from '../types/FormatCompte';
//import { DetailFormatCompte } from '../types/DetailFormatCompte';
//import { DetailFormatCompte } from '../interfaces/GlobalInterface';
import { DetailFormatCompte } from '../../../dataTypes/GlobalDataType';
//import { FormatCompte } from '../interfaces/GlobalInterface';
import { FormatCompte } from '../../../dataTypes/GlobalDataType';
//import { apiEndpoints } from '../config';
import { apiEndpoints } from '../../../config';
//import FormatComptePage3 from './FormatComptePage3';
import FormatCompte3 from './FormatCompte3';
import Utilisateur from '../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';

import { Crypter } from '../../../Functions/Security/Crypter';
import Hash from '../../../Functions/Security/Hash';
import Agence from '../../../Models/Agence';
import { lib } from 'crypto-js';
import Data from "../../../Data/Data.json"

// --- Fonctions utilitaires ---
const formatDateTimeForDisplay = (isoString: string | null | undefined): string => {
  if (!isoString) return 'N/A';
  try {
    return new Date(isoString).toLocaleString('fr-FR');
  } catch {
    return 'Format invalide';
  }
};

// --- URL de votre API ---
const API_URL = Data.ApiUrl.FormatCompte;

function FormatCompte1() {
  const [formats, setFormats] = useState<FormatCompte[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [currentFormat, setCurrentFormat] = useState<FormatCompte | null>(null);
  const [dialogError, setDialogError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

   // State to control the dialog's visibility
  const [openDialog2, setOpenDialog2] = useState(false);
  // State to hold the ID of the format to display in the dialog
  const [selectedFormatId2, setSelectedFormatId2] = useState<number | null>(null);

   //const { user, logout } = useAuth();
  const auth = useAuthUser()
     const user: Utilisateur = JSON.parse(JSON.stringify(auth()))
    // USER TOKEN
    const authHeader = useAuthHeader()
  

  // --- Charger tous les formats ---
  const fetchFormats = async () => {
    setLoading(true);
    setError(null);
    try {

      var config = {
                  method: 'get',
                  maxBodyLength: Infinity,
                  url: apiEndpoints.formatcompte,
                  headers: {
                  'Authorization': authHeader(),
                  'Content-Type': 'application/json',
                 // CypherLib:Rubri
                       },
                   };
                    axios.request(config)
                      .then(function (response) {
                         if (response.data) {
                               
                           setFormats(response.data)
                                                                 
                                  }
                                })
      // const response = await axios.get(apiEndpoints.formatcompte);
      // //const res = JSON.parse(response.data);
      //   // const listText = JSON.stringify(response.data);
      //     console.log(response.data.Table)
       

     // setFormats(response.data.value);
    } catch (err) {
      console.error("Erreur de chargement des formats:", err);
      setError("Impossible de charger les formats de compte.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFormats();
  }, []);

  // --- Ouvrir le dialogue (Ajouter/Modifier) ---
  const handleOpenDialog = async (formatToEdit: FormatCompte | null = null) => {
    setDialogError(null);
    if (formatToEdit) {
      setLoading(true); // Charger le format avec ses détails
      try {

       // console.log("Format to edit:", formatToEdit);
        //  var config = {
        //           method: 'get',
        //           maxBodyLength: Infinity,
        //           url: `${apiEndpoints.formatcompte}/${formatToEdit.idFormat}`,
        //           headers: {
        //           'Authorization': authHeader(),
        //           'Content-Type': 'application/json',
        //           id:formatToEdit.idFormat
        //                },
        //            };

        var config = {
  method: 'get',
  url: `${apiEndpoints.formatcompte}/${formatToEdit.idFormat}`,
  headers: {
    'Authorization': authHeader(), // authHeader() doit renvoyer 'Bearer ...'
    'Content-Type': 'application/json'
  }
};

                    axios.request(config)
                         .then(function (response) {
                          if (response.data) {
        setCurrentFormat(response.data);
      }

                        console.log("Format to edit1234:", response.data)   
                         if (response.data) {
                           //console.log("Format to edit1234:", response.data)    
                           setCurrentFormat(response.data)
                                                                 
                                  }
                                })
       // const response = await axios.get<FormatCompte>(`${apiEndpoints.formatcompte}/${formatToEdit.idFormat}`);
       // console.log("Format to edit1234:", response.data);
       // setCurrentFormat(response.data); // Le format avec ses détails
      } catch (err) {
        console.error("Erreur de chargement du format pour édition:", err);
        setDialogError("Impossible de charger les détails du format pour édition.");
        setCurrentFormat(null);
      } finally {
        setLoading(false);
      }
    } else {
      // Nouvel ajout
      setCurrentFormat({
        idFormat: 0, // Pour un nouveau format, l'ID est 0 ou null
        nomFormat: '',
        separateur: '-',
        description: '',
        estActif: true,
        utilisateurCreation: user.coduti, // Exemple: à remplacer par l'utilisateur connecté
        dateCreation: new Date().toISOString(),
        details: [ // Initialiser avec les groupes par défaut
          { nomGroupe: 'PlanComptable', longueur: 0, positionDepart: 0, ordreAffichage: 1 },
          { nomGroupe: 'CodeProduit', longueur: 0, positionDepart: 0, ordreAffichage: 2 },
          { nomGroupe: 'Codage', longueur: 0, positionDepart: 0, ordreAffichage: 3 },
          { nomGroupe: 'NumeroClient', longueur: 0, positionDepart: 0, ordreAffichage: 4 },
          { nomGroupe: 'ClefDeCompte', longueur: 0, positionDepart: 0, ordreAffichage: 5 }
        ]
      });
    }
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setCurrentFormat(null);
    setDialogError(null);
  };

  const handleFormatInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    let newValue: string | boolean = value;

    // Type guard to ensure e.target is an HTMLInputElement before checking 'type' and 'checked'
    if (e.target instanceof HTMLInputElement) {
        if (e.target.type === 'checkbox') {
            newValue = e.target.checked;
        }
    }

    setCurrentFormat(prev => {
        if (!prev) return null;
        return {
            ...prev,
            [name]: newValue
        };
    });
};
  // --- Gérer les changements d'input dans le formulaire principal du format ---
//   const handleFormatInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    
//     const { name, value, type, checked } = e.target;
//     setCurrentFormat(prev => {
//       if (!prev) return null;
//       return {
//         ...prev,
//         [name]: type === 'checkbox' ? checked : value
//       };
//     });
//   };

  // --- Gérer les changements d'input pour les détails des groupes ---
  const handleDetailInputChange = (
    index: number,
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setCurrentFormat(prev => {
      if (!prev || !prev.details) return null;
      const newdetails = [...prev.details];
      newdetails[index] = {
        ...newdetails[index],
        [name]: (name === 'longueur' || name === 'positionDepart' || name === 'ordreAffichage') ? parseInt(value) || 0 : value
      };
      return { ...prev, details: newdetails };
    });
  };

  // --- Ajouter un nouveau détail (si on veut permettre des groupes personnalisés) ---
  const handleAddDetail = () => {
    setCurrentFormat(prev => {
      if (!prev) return null;
      const newdetails = prev.details ? [...prev.details] : [];
      newdetails.push({
        nomGroupe: '',
        longueur: 0,
        positionDepart: 0,
        ordreAffichage: newdetails.length > 0 ? Math.max(...newdetails.map(d => d.ordreAffichage || 0)) + 1 : 1,
      });
      return { ...prev, details: newdetails };
    });
  };

  // --- Supprimer un détail ---
  const handleDeleteDetail = (index: number) => {
    setCurrentFormat(prev => {
      if (!prev || !prev.details) return null;
      const newdetails = prev.details.filter((_, i) => i !== index);
      // Réajuster les ordres d'affichage si nécessaire
      newdetails.forEach((detail, i) => detail.ordreAffichage = i + 1);
      return { ...prev, details: newdetails };
    });
  };

  // --- Déplacer un détail vers le haut/bas pour changer l'ordre ---
  const handleMoveDetail = (index: number, direction: 'up' | 'down') => {
    setCurrentFormat(prev => {
      if (!prev || !prev.details) return null;
      const newdetails = [...prev.details];
      const targetIndex = direction === 'up' ? index - 1 : index + 1;

      if (targetIndex >= 0 && targetIndex < newdetails.length) {
        // Swap elements
        [newdetails[index], newdetails[targetIndex]] = [newdetails[targetIndex], newdetails[index]];

        // Re-assign ordreAffichage based on new visual order
        newdetails.forEach((detail, i) => detail.ordreAffichage = i + 1);

        return { ...prev, details: newdetails };
      }
      return prev;
    });
  };

  // --- Soumettre le formulaire (Créer/Mettre à jour) ---
  const handleSubmit = async () => {
    if (!currentFormat) return;

    setSubmitting(true);
    setDialogError(null);

    // Validation des champs principaux
    if (!currentFormat.nomFormat) {
      setDialogError("Le nom du format est obligatoire.");
      setSubmitting(false);
      return;
    }

    // Validation des détails : s'assurer qu'il n'y a pas de doublons nomGroupe/ordreAffichage, et que les valeurs sont valides
    if (currentFormat.details) {
      const nomGroupes = new Set<string>();
      const ordresAffichage = new Set<number>();
      for (const detail of currentFormat.details) {
        if (!detail.nomGroupe) {
          setDialogError("Tous les noms de groupe dans les détails sont obligatoires.");
          setSubmitting(false);
          return;
        }
        if (nomGroupes.has(detail.nomGroupe)) {
          setDialogError(`Nom de groupe dupliqué: ${detail.nomGroupe}.`);
          setSubmitting(false);
          return;
        }
        nomGroupes.add(detail.nomGroupe);

        if (ordresAffichage.has(detail.ordreAffichage)) {
          setDialogError(`Ordre d'affichage dupliqué: ${detail.ordreAffichage}.`);
          setSubmitting(false);
          return;
        }
        ordresAffichage.add(detail.ordreAffichage);

        if (detail.longueur <= 0 || detail.positionDepart <= 0 || detail.ordreAffichage <= 0) {
          setDialogError(`longueur, position de départ et ordre d'affichage doivent être supérieurs à 0 pour tous les détails.`);
          setSubmitting(false);
          return;
        }
      }

      // Calculer et valider les positions départ
      let currentPosition = 1;
      const sorteddetails = [...currentFormat.details].sort((a, b) => (a.ordreAffichage || 0) - (b.ordreAffichage || 0));

      for (let i = 0; i < sorteddetails.length; i++) {
        const detail = sorteddetails[i];
        if (detail.positionDepart !== currentPosition) {
          setDialogError(`Erreur de position pour '${detail.nomGroupe}': la position de départ devrait être ${currentPosition}.`);
          setSubmitting(false);
          return;
        }
        currentPosition += detail.longueur + (currentFormat.separateur?.length || 0); // Ajouter la longueur du séparateur
        if (i < sorteddetails.length - 1 && currentFormat.separateur) {
             // Pour le prochain segment, sa position de départ sera après le séparateur du segment actuel
             // On s'assure que le séparateur est pris en compte pour la *prochaine* position de départ.
             // La position de départ du segment suivant commence APRES le séparateur.
             // Cette logique est un peu tricky et dépend de votre définition exacte de "positionDepart".
             // Pour la démo, on s'attend à ce que positionDepart du segment suivant soit (positionDepart du courant + longueur du courant + longueur du séparateur)
        }
      }
    }


    try {
      const isNew = !currentFormat.idFormat; // Si idFormat est null/undefined, c'est une création

      if (isNew) {
        await axios.post<FormatCompte>(apiEndpoints.formatcompte, currentFormat);
        alert('Format de compte ajouté avec succès!');
      } else {
        await axios.put(`${apiEndpoints.formatcompte}/${currentFormat.idFormat}`, currentFormat);
        alert('Format de compte mis à jour avec succès!');
      }
      handleCloseDialog();
      fetchFormats(); // Recharger la liste
    } catch (err) {
      console.error("Erreur de soumission du format:", err);
      if (axios.isAxiosError(err) && err.response) {
        setDialogError(`Erreur: ${err.response.data || err.message}`);
      } else {
        setDialogError("Une erreur inattendue est survenue lors de l'enregistrement du format.");
      }
    } finally {
      setSubmitting(false);
    }
  };

  // --- Supprimer un format ---
  const handleDeleteFormat = async (idFormat: number, nomFormat: string) => {
    const confirmDelete = window.confirm(`Êtes-vous sûr de vouloir supprimer le format '${nomFormat}' et tous ses détails associés?`);
    if (!confirmDelete) return;

    setLoading(true);
    setError(null);
    try {
      await axios.delete(`${apiEndpoints.formatcompte}/${idFormat}`);
      alert('Format de compte supprimé avec succès!');
      fetchFormats();
    } catch (err) {
      console.error("Erreur de suppression du format:", err);
      if (axios.isAxiosError(err) && err.response) {
        setError(`Erreur: ${err.response.data || err.message}`);
      } else {
        setError("Impossible de supprimer le format de compte.");
      }
    } finally {
      setLoading(false);
    }
  };

  // --- Supprimer un format ---
  const handleShowFormat =  (Id: number, nomFormat: string) => {
    setSelectedFormatId2(Id); // Set the ID that FormatComptePage3 will receive
    setOpenDialog2(true); // Open the dialog
    // You might also want to set a selectedFormatName if needed for dialog title etc.
  };

  // Function to close the dialog
  const handleCloseDialog2 = () => {
    setOpenDialog2(false);
    setSelectedFormatId2(null); // Clear the selected ID when closing
  };

  if (loading && formats.length === 0) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px' }}>
        <CircularProgress />
        <Typography variant="h6" sx={{ ml: 2 }}>Chargement des formats...</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3, maxWidth: '1200px', margin: 'auto' }}>
      <Typography variant="h6" gutterBottom>
        Gestion des Formats de Compte
      </Typography>

      <Button
        variant="contained"
        startIcon={<AddIcon />}
        onClick={() => handleOpenDialog()}
        sx={{ mb: 2 }}
      >
        Ajouter
      </Button>

      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

      <TableContainer component={Paper} elevation={3} sx={{ maxHeight: 600, overflowY: 'auto' }}>
        <Table stickyHeader aria-label="table des formats de compte">
          <TableHead>
            <TableRow>
              <TableCell sx={{ backgroundColor: "#107C41", color: '#fff' }}>ID</TableCell>
              <TableCell sx={{ backgroundColor: "#107C41", color: '#fff' }}>Nom du Format</TableCell>
              <TableCell sx={{ backgroundColor: "#107C41", color: '#fff' }}>Séparateur</TableCell>
              <TableCell sx={{ backgroundColor: "#107C41", color: '#fff' }}>Exemple</TableCell>
              <TableCell sx={{ backgroundColor: "#107C41", color: '#fff' }}>Actif</TableCell>
              <TableCell sx={{ backgroundColor: "#107C41", color: '#fff' }}>Créé par</TableCell>
              <TableCell sx={{ backgroundColor: "#107C41", color: '#fff' }}>Date Création</TableCell>
              <TableCell sx={{ backgroundColor: "#107C41", color: '#fff' }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {formats.length === 0 ? (
              <TableRow>
                <TableCell colSpan={8} align="center">Aucun format de compte trouvé.</TableCell>
              </TableRow>
            ) : (
              formats.map((format) => (
                
                  <TableRow key={format.idFormat}>
                  <TableCell>{format.idFormat}</TableCell>
                  <TableCell>{format.nomFormat}</TableCell>
                  <TableCell>{format.separateur || 'N/A'}</TableCell>
                  <TableCell>{format.exemple || 'N/A'}</TableCell>
                  <TableCell>{format.estActif ? 'Oui' : 'Non'}</TableCell>
                  <TableCell>{format.utilisateurCreation || 'N/A'}</TableCell>
                  <TableCell>{format.dateCreation?.toString()}</TableCell>
                  <TableCell>
                    <IconButton color="primary" onClick={() => handleOpenDialog(format)}>
                      <EditIcon />
                    </IconButton>
                    <IconButton color="info" onClick={() => handleShowFormat(format.idFormat, format.nomFormat)}>
                      < ViewListIcon/>
                    </IconButton>
                    <IconButton color="error" onClick={() => handleDeleteFormat(format.idFormat, format.nomFormat)}>
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
              
            )}
            
          </TableBody>
        </Table>
      </TableContainer>

        {/* The Dialog component, rendered conditionally based on openDialog state */}
      <Dialog open={openDialog2} onClose={handleCloseDialog2} maxWidth="md" fullWidth>
        <DialogTitle>
          {/* Only render FormatComptePage3 if selectedFormatId is not null */}
          {selectedFormatId2 !== null && <FormatCompte3 formatId={selectedFormatId2} />}
        </DialogTitle>
        {/* You can add DialogContent and DialogActions here if needed */}
      </Dialog>

      {/* --- Dialogue pour Ajouter/Modifier un Format --- */}
      <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md" fullWidth>
        <DialogTitle>
          {currentFormat?.idFormat ? "Modifier Format de Compte" : "Ajouter Nouveau Format de Compte"}
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500] }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {dialogError && <Alert severity="error" sx={{ mb: 2 }}>{dialogError}</Alert>}
          {currentFormat && (
            <Box component="form" sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <TextField
                label="Nom du Format"
                name="nomFormat"
                value={currentFormat.nomFormat}
                onChange={handleFormatInputChange}
                required
                disabled={currentFormat.idFormat !== undefined} // Désactiver si c'est une édition
              />
              <TextField
                label="Séparateur"
                name="separateur"
                value={currentFormat.separateur || ''}
                onChange={handleFormatInputChange}
                helperText="Ex: -, ., _ (laisser vide si pas de séparateur)"
              />
              <TextField
                label="description"
                name="description"
                value={currentFormat.description || ''}
                onChange={handleFormatInputChange}
                multiline
                rows={2}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={currentFormat.estActif}
                    onChange={handleFormatInputChange}
                    name="estActif"
                  />
                }
                label="Actif"
              />

              <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>
                Détails des Groupes de Compte
              </Typography>
              {/* <Button
                variant="outlined"
                size="small"
                startIcon={<AddIcon />}
                onClick={handleAddDetail}
                sx={{ mb: 2 }}
              >
                Ajouter un groupe personnalisé (si besoin)
              </Button> */}

              <TableContainer component={Paper} elevation={1} sx={{ maxHeight: 300, overflowY: 'auto' }}>
                <Table size="small" stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ backgroundColor: "#107C41", color: '#fff' }}>Ordre</TableCell>
                      <TableCell sx={{ backgroundColor: "#107C41", color: '#fff' }}>Nom du Groupe</TableCell>
                      <TableCell sx={{ backgroundColor: "#107C41", color: '#fff' }}>longueur</TableCell>
                      <TableCell sx={{ backgroundColor: "#107C41", color: '#fff' }}>Pos. Départ</TableCell>
                      <TableCell sx={{ backgroundColor: "#107C41", color: '#fff' }}>Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {currentFormat.details && currentFormat.details.length > 0 ? (
                      currentFormat.details
                      .sort((a, b) => (a.ordreAffichage || 0) - (b.ordreAffichage || 0)) // Toujours trier par ordre d'affichage
                      .map((detail, index) => (
                        <TableRow key={detail.idDetail || `new-${index}`}>
                          <TableCell sx={{ width: '80px' }}>
                            <TextField
                                type="number"
                                name="ordreAffichage"
                                value={detail.ordreAffichage || ''}
                                onChange={(e) => handleDetailInputChange(index, e)}
                                inputProps={{ min: 1 }}
                                size="small"
                                sx={{ width: '60px' }}
                            />
                             <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                <IconButton size="small" onClick={() => handleMoveDetail(index, 'up')} disabled={index === 0}>
                                    <ArrowUpwardIcon fontSize="inherit" />
                                </IconButton>
                                <IconButton size="small" onClick={() => handleMoveDetail(index, 'down')} disabled={index === (currentFormat.details?.length || 0) - 1}>
                                    <ArrowDownwardIcon fontSize="inherit" />
                                </IconButton>
                            </Box>
                          </TableCell>
                          <TableCell>
                            <TextField
                              name="nomGroupe"
                              value={detail.nomGroupe}
                              onChange={(e) => handleDetailInputChange(index, e)}
                              required
                              size="small"
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              type="number"
                              name="longueur"
                              value={detail.longueur || ''}
                              onChange={(e) => handleDetailInputChange(index, e)}
                              inputProps={{ min: 1 }}
                              required
                              size="small"
                              sx={{ width: '80px' }}
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              type="number"
                              name="positionDepart"
                              value={detail.positionDepart || ''}
                              onChange={(e) => handleDetailInputChange(index, e)}
                              inputProps={{ min: 1 }}
                              required
                              size="small"
                              sx={{ width: '80px' }}
                            />
                          </TableCell>
                          <TableCell>
                            <IconButton color="error" onClick={() => handleDeleteDetail(index)}>
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={5} align="center">Aucun détail de groupe défini.</TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
         
          <Button onClick={handleSubmit} startIcon={<SaveIcon />} variant="contained" disabled={submitting}>
            {submitting ? <CircularProgress size={24} /> : "Enregistrer"}
          </Button>
           <Button onClick={handleCloseDialog} startIcon={<CancelIcon />} variant="contained" >Annuler</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default FormatCompte1;